
// import libs
// 

var $header = $('#header');
var headerHeight = $header.outerHeight();

// import components
import './components/ie-detection.js';
import './components/menu.js';
// import './components/modal.js';

// init

// ----------------------------------------
//  scroll to
var $scrollToItems = $('.scrollTo');
$.each($scrollToItems, function() {
    $(this).on('click', function(e) {
        e.preventDefault();

        var href = $(this).attr('href');
        if (typeof href === 'undefined') {
            href = $(this).attr('data-href');
        }
        var offset = $(this).attr('data-offset');

        // if booking strip scroll to
        if ($(this).hasClass('scrolling-strip')) {
            const mq = window.matchMedia( "(max-width: 576px)" );
            if (mq.matches) {
                offset = 0;
            }
        }

        var $target = $(href);
        if ($target.length) {
            $('html,body').animate({
                scrollTop: $target.offset().top - headerHeight + ((typeof offset !== 'undefined') ? parseInt(offset) : 0)
            }, {
                duration: 300,
                easing: 'swing'
            });
        }
    });
});
// ----------------------------------------

// scripts here
// ----------------------------------------

// Bootstrap dropdown
// $('.dropdown-toggle').dropdown();

// collapse
// $('.collapse__toggle, .collapse__toggle > label').on('click', function(e) {
//     $(this).closest('.collapse').toggleClass('show');
// });

if ($('#teaserCarousel').length) {
    var teaserCarousel = tns({
      container: '#teaserCarousel',  
      items: 1,
      speed: 1000,
      autoplay: true,
      autoplayTimeout: 10000,
      mouseDrag: true,
      touch: true,
      loop: true,
      nav: true,
      controls: true,
      autoplayButton: false,
      autoplayButtonOutput: false,
      navContainer: '#teaserCarouselNav',    
    });
  }
  
if ($('#partnersCarousel').length) {
    var partnersCarousel = tns({
        container: '#partnersCarousel',  
        items: 5,
        speed: 1000,
        autoplay: true,
        autoplayTimeout: 10000,
        mouseDrag: true,
        touch: true,
        loop: true,
        nav: false,
        controls: false,
        autoplayButton: false,
        autoplayButtonOutput: false,
    });
}

if ($('#shopsCarousel').length) {
    var shopsCarousel = tns({
        container: '#shopsCarousel',  
        items: 3,
        speed: 1000,
        autoplay: true,
        autoplayTimeout: 10000,
        mouseDrag: true,
        touch: true,
        loop: true,
        nav: false,
        controls: false,
        autoplayButton: false,
        autoplayButtonOutput: false,
        responsive: {
            577: {              
              items: 5
            },
            769: {
              items: 7
            },            
        }
    });
}

if ($('.carousel--default').length) {
    var carouselDefault = tns({
        container: '.carousel--default',  
        items: 2,
        speed: 1000,
        autoplay: false,
        autoplayTimeout: 10000,
        mouseDrag: false,
        touch: true,
        loop: true,
        nav: true,
        controls: false,
        autoplayButton: false,
        autoplayButtonOutput: false,
        responsive: {
            577: {              
              items: 3
            }                
        }
    });
}

function initLightbox() {
    $('.gallery').each(function() { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a',
            gallery: {
                enabled: true
            },
            type: 'image',
            removalDelay: 500, //delay removal by X to allow out-animation
            callbacks: {
            beforeOpen: function() {
                // just a hack that adds mfp-anim class to markup
                this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
                this.st.mainClass = this.st.el.attr('data-effect');
            }
            },
            image: {
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                titleSrc: function(item) {
                    return '';
                }
            },
            closeOnContentClick: true,
            midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
        });
    });
}
initLightbox();